import gql from "graphql-tag";

export default gql`
  query {
    inventoryItems {
      id
      name
      unit
      code
      materialType
      inventoryLocations {
        id
        name
        code
        inventoryQuantity
        sensor {
          id
          name
        }
      }
    }
  }
`;
